<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--120 pb--190 banner-service-details-notin"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100 ">
              <h1 class="headingtitle">Política de Cookies</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="inner">
              <!-- Start Single Content  -->
              <v-row
                class="pb--80 align-items-center text-justify"
              >
                <v-col lg="12" md="12" cols="12">
                  <div class="contentlegal details mt_md--30 mt_sm--30" v-if="NOTARIA.CookiesPage " v-html="NOTARIA.CookiesPage"></div>
                  <div class="contentlegal details mt_md--30 mt_sm--30" v-if="!NOTARIA.CookiesPage ">
                    <h2>¿Qué son las Cookies?</h2>
                    <p>
                    Las cookies son archivos que se pueden descargar en su equipo a través de las páginas web. Son herramientas que tienen un papel esencial para la prestación de numerosos servicios de la sociedad de la información. Entre otros, permiten a una página web almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información obtenida, se pueden utilizar para reconocer al usuario y mejorar el servicio ofrecido.
                    </p>
                    <h3>Tipos de Cookies</h3>
                    <p>
                    Tipos de cookies Según quien sea la entidad que gestione el dominio desde donde se envían las cookies y trate los datos que se obtengan se pueden distinguir dos tipos:
                    <ul>
                        <li>
                            Cookies propias: Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.
                        </li>
                        <li>
                            Cookies de terceros: Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies.
                        </li>
                    </ul>
                    </p>
                    <p>
                    En el caso de que las cookies sean instaladas desde un equipo o dominio gestionado por el propio editor pero la información que se recoja mediante éstas sea gestionada por un tercero, no pueden ser consideradas como cookies propias.

                    Existe también una segunda clasificación según el plazo de tiempo que permanecen almacenadas en el navegador del cliente, pudiendo tratarse de:
                    <ul>
                        <li>
                            Cookies de sesión: Diseñadas para recabar y almacenar datos mientras el usuario accede a una página web. Se suelen emplear para almacenar información que solo interesa conservar para la prestación del servicio solicitado por el usuario en una sola ocasión (p.e. una lista de productos adquiridos).
                        </li>
                        <li>
                            Cookies persistentes: Los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie, y que puede ir de unos minutos a varios años.
                        </li>
                    </ul>
                    </p>
                    <p>
                    Por último, existe otra clasificación con cinco tipos de cookies según la finalidad para la que se traten los datos obtenidos:
                    <ul>
                        <li>
                            Cookies técnicas: Aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de vídeos o sonido o compartir contenidos a través de redes sociales.
                        </li>
                        <li>
                            Cookies de personalización: Permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde donde accede al servicio, etc.
                        </li>
                        <li>
                            Cookies de análisis: Permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.
                        </li>
                        <li>
                            Cookies publicitarias: Permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios.
                        </li>
                        <li>
                            Cookies de publicidad comportamental: Almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.
                        </li>
                        <li>
                            Cookies de redes sociales externas: Se utilizan para que los visitantes puedan interactuar con el contenido de diferentes plataformas sociales (facebook, youtube, twitter, linkedIn, etc..) y que se generen únicamente para los usuarios de dichas redes sociales. Las condiciones de utilización de estas cookies y la información recopilada se regula por la política de privacidad de la plataforma social correspondiente.
                        </li>
                    </ul>
                    </p>

                    <h2>Desactivación y eliminación de Cookies</h2>
                    <p>
                    Tienes la opción de permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuración de las opciones del navegador instalado en su equipo. Al desactivar cookies, algunos de los servicios disponibles podrían dejar de estar operativos. La forma de deshabilitar las cookies es diferente para cada navegador, pero normalmente puede hacerse desde el menú Herramientas u Opciones. También puede consultarse el menú de Ayuda del navegador dónde puedes encontrar instrucciones. El usuario podrá en cualquier momento elegir qué cookies quiere que funcionen en este sitio web.
                    <br>
                    Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador:
                    <ul>
                        <li>
                            Chrome: https://support.google.com/accounts/answer/61416?hl=es
                        </li>
                        <li>
                            Microsoft Internet Explorer o Microsoft Edge: http://windows.microsoft.com/es-es/windows-vista/Block-or-allow-cookies
                        </li>
                        <li>  
                            Mozilla Firefox: http://support.mozilla.org/es/kb/impedir-que-los-sitios-web-guarden-sus-preferencia
                        </li>
                        <li>   
                            Safari: http://safari.helpmax.net/es/privacidad-y-seguridad/como-gestionar-las-cookies/
                        </li>
                        <li> 
                            Opera: http://help.opera.com/Linux/10.60/es-ES/cookies.html
                        </li>
                    </ul>
                   
                    Además, también puede gestionar el almacén de cookies en su navegador a través de herramientas como las siguientes:
                    <ul>
                        <li>
                            Ghostery: www.ghostery.com
                        </li>
                        <li>
                            Your online choices: www.youronlinechoices.com/es/
                        </li>
                    </ul>
                    </p>    

                    <h2>Cookies utilizadas en {{NOTARIA.Ruta}}</h2>
                    <p>
                    La Web de {{NOTARIA.Ruta}} puede utilizar servicios de terceros que, por cuenta de {{NOTARIA.Ruta}}, recopilaran información con fines estadísticos, de uso del Site por parte del usuario y para la prestación de otros servicios relacionados con la actividad del Website y otros servicios de Internet.
                    <br>
                    En particular, este sitio Web utiliza, entre otros, Google Analytics, un servicio analítico de web prestado por Google, Inc. con domicilio en los Estados Unidos con sede central en 1600 Amphitheatre Parkway, Mountain View, California 94043. Para la prestación de estos servicios, estos utilizan cookies que recopilan la información, incluida la dirección IP del usuario, que será transmitida, tratada y almacenada por Google en los términos fijados en la Web Google.com. Incluyendo la posible transmisión de dicha información a terceros por razones de exigencia legal o cuando dichos terceros procesen la información por cuenta de Google.
                    <br>
                    El Usuario acepta expresamente, por la utilización de este Site, el tratamiento de la información recabada en la forma y con los fines anteriormente mencionados. Y asimismo reconoce conocer la posibilidad de rechazar el tratamiento de tales datos o información rechazando el uso de Cookies mediante la selección de la configuración apropiada a tal fin en su navegador. Si bien esta opción de bloqueo de Cookies en su navegador puede no permitirle el uso pleno de todas las funcionalidades del Website.
                    </p>

                    <h2>Aceptación de la política de Cookies</h2>
                    <p>
                    {{NOTARIA.Ruta}} asume que usted acepta el uso de cookies. No obstante, muestra información sobre su Política de cookies en la parte inferior de cualquier página del portal con cada inicio de sesión con el objeto de que usted sea consciente.

                    Ante esta información es posible llevar a cabo las siguientes acciones:
                    <ul>
                        <li>
                            Aceptar cookies. No se volverá a visualizar este aviso al acceder a cualquier página del portal durante la presente sesión.
                        </li>
                        <li> 
                            Cerrar. Se oculta el aviso en la presente página.
                        </li>
                    </ul>
                    </p>
                  </div>
                </v-col>
              </v-row>
              <!-- End Single Content  -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore();
const { NOTARIA } = storeToRefs(store)
</script>
